import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Directions,
  centerActivityConstants,
  centerActivityStatusEnum,
  eventConstants,
  fieldLengthConstants,
  globalConstants,
  globalGridActions,
  modeConstants,
  translationConstants,
  viewPathConstants,
  eventStatusEnum,
  EVENT_STATUS,
  timezoneConstants,
  competitionProvidedServices,
  sportConstants,
} from "../../../../../constants";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row, Form } from "react-bootstrap";
import { Controller, FormProvider, useForm } from "react-hook-form";
import InputFieldWrapper from "../../../../../shared/components/InputFieldWrapper/InputFieldWrapper";
import ReactDatePickerWrapper from "../../../../../shared/components/ReactDatePickerWrapper/ReactDatePickerWrapper";
import FileUploader from "../../../../../shared/components/UploadFile/FileUploader";
import moment from "moment";
import CustomModal from "../../../../../shared/components/CustomModal/CustomModal";
import FindOnMapModal from "../../../../../shared/components/Modals/FindOnMapModal";
import {
  EventActions,
  SpotActions,
  authActions,
} from "../../../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import {
  appendMandatorySignAndTimezoneText,
  convertObjectToFormData,
  UTCWithTimezoneToISOString,
  mergeDateTimeToServerFormat,
  serverFormatToDateObject,
  replaceLocalToUTCFormatZ,
} from "../../../../../system";
import { useNavigate, useLocation } from "react-router-dom";
import { Direction } from "react-data-table-component";
import ConfirmationModal from "../../../../../shared/components/Modals/ConfirmationModal";
import MultiSelect from "../../../../../shared/components/MultiSelect/MultiSelect";

const LocationConstants = {
  PUBLIC_SPOT: 0,
  PRIVATE_SPOT: 1,
  CUSTOM_LOCATION: 2,
};

const initialGridState = {
  length: 10,
  pageNumber: 1,
  orderBy: "EventInfo.Id desc",
  filterQuery: "",
  search: "",
};

const EventForm = (props) => {
  const { Mandatory_Character } = globalConstants;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isReistrationFees, setIsReistrationFees] = useState(true);
  const [isEventPrivate, setIsEventPrivate] = useState(false);
  const [isSpecialMemberFeeEnable, setIsSpecialMemberFeeEnable] =
    useState(false);
  const [isShowMap, setShowMap] = useState(false);
  const [selectedSpotType, setSelectedSpotType] = useState(
    LocationConstants.PUBLIC_SPOT
  );
  const [lng, setLng] = useState("");
  const [lat, setLat] = useState("");
  const [posterMessage, setPosterMessage] = useState("");
  const [logoMessage, setLogoMessage] = useState("");
  const [userType, setUserType] = useState([]);
  const [isStartDateChanged, setIsStartDateChanged] = useState(false);
  const [isLocationChanged, setIsLocationChanged] = useState(false);
  const [isLogoChanged, setIsLogoChanged] = useState(false);
  const [isPosterChanged, setIsPosterChanged] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [editInformationMessage, setEditInformationMessage] = useState("");
  const [modalData, setModalData] = useState(null);
  const [modalEvent, setModalEvent] = useState(null);
  const [isExclusiveForMembers, setIsExclusiveForMembers] = useState(false);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleServiceCheckboxChange = (value) => {
    setSelectedServices((prevSelected) =>
      prevSelected.includes(value)
        ? prevSelected.filter((service) => service !== value)
        : [...prevSelected, value]
    );
  };

  const cities = useSelector((state) => state.LoginReducer.cities);
  const spots = useSelector(
    (state) => state.SpotsReducer.allApprovedPublicPrivateSpots
  );
  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );

  const searchParams = new URLSearchParams(location.search);
  const eventId = searchParams.get("eventId");
  const mode = searchParams.get("mode");

  const eventData = useSelector(
    (state) => state.eventReducer.eventDataByIdWithDocs
  );

  useEffect(() => {
    if (mode === modeConstants.EDIT_MODE) {
      dispatch(EventActions.getEventByIdWithDocs(eventId));
    }
    //eslint-disable-next-line
  }, [dispatch, eventId, mode]);

  const methods = useForm();
  const {
    setValue,
    getValues,
    register,
    handleSubmit,
    formState: { errors },
    control,
    trigger,
    clearErrors,
    setError,
  } = methods;

  const handleCheckboxChange = (checkboxId) => {
    setSelectedSpotType(checkboxId);
    setValue("eventInfo.cityId", "");
    if (checkboxId !== LocationConstants.CUSTOM_LOCATION) {
      clearErrors("eventInfo.Lat");
      clearErrors("eventInfo.Long");
      setValue("eventInfo.cityId", null);
    }
  };

  const onSetShowMap = () => {
    const latitude = getValues("eventInfo.lat");
    const longitude = getValues("eventInfo.long");
    setLat(latitude);
    setLng(longitude);
    setShowMap((prev) => !prev);
  };

  const handleSaveLocation = () => {
    setValue("eventInfo.lat", lat);
    setValue("eventInfo.long", lng);
    trigger("eventInfo.lat");
    trigger("eventInfo.long");
    setShowMap(false);
  };

  useEffect(() => {
    setValue("eventInfo.eventType", eventConstants.PUBLIC);
  }, [methods]);

  const serviceOptions = [
    {
      label: t(translationConstants.LEAVE_LETTER),
      value: competitionProvidedServices.LEAVE_LETTER,
    },
    {
      label: t(translationConstants.ACCOMMODATION),
      value: competitionProvidedServices.ACCOMMODATION,
    },
    {
      label: t(translationConstants.FLIGHTS),
      value: competitionProvidedServices.FLIGHTS,
    },
    {
      label: t(translationConstants.MEALS),
      value: competitionProvidedServices.MEALS,
    },
    {
      label: t(translationConstants.SNACKS_AND_WATER),
      value: competitionProvidedServices.SNACKS_AND_WATER,
    },
  ];

  useEffect(() => {
    // Fetch cities and spots
    dispatch(authActions.fetchCities(process.env.REACT_APP_Country_Id));
    dispatch(SpotActions.getAllApprovedSpots());

    if (mode === modeConstants.EDIT_MODE && eventId && eventData) {
      // Populate form fields with the event data
      const eventInfo = eventData?.eventInfo;
      Object.keys(eventInfo).forEach((key) => {
        setValue(`eventInfo.${key}`, eventInfo[key]);
      });

      if (eventInfo?.providedServices) {
        const providedServicesArray = eventInfo.providedServices
          .split(", ")
          .map((service) => service.trim());
        setSelectedServices(providedServicesArray);
      }

      eventInfo?.startDateString &&
        setValue(
          "eventInfo.startDateString",
          serverFormatToDateObject(eventInfo?.startDateString)
        );
      eventInfo?.endDateString &&
        setValue(
          "eventInfo.endDateString",
          serverFormatToDateObject(eventInfo?.endDateString)
        );
      eventInfo?.startDateString &&
        setValue(
          "eventInfo.startTime",
          serverFormatToDateObject(eventInfo?.startDateString)
        );
      eventInfo?.endDateString &&
        setValue(
          "eventInfo.endTime",
          serverFormatToDateObject(eventInfo?.endDateString)
        );
      eventInfo?.registrationStartDateString &&
        setValue(
          "eventInfo.registrationStartDateString",
          serverFormatToDateObject(eventInfo?.registrationStartDateString)
        );
      eventInfo?.registrationEndDateString &&
        setValue(
          "eventInfo.registrationEndDateString",
          serverFormatToDateObject(eventInfo?.registrationEndDateString)
        );

      if (eventInfo?.registrationFee) {
        setIsReistrationFees(true);
        setValue("eventInfo.registrationFee", eventInfo?.registrationFee);
      } else {
        setIsReistrationFees(false);
      }

      if (eventInfo?.specialMemberFee) {
        setIsSpecialMemberFeeEnable(true);
        setValue("eventInfo.specialMemberFee", eventInfo?.specialMemberFee);
      } else {
        setIsSpecialMemberFeeEnable(false);
      }

      if (
        eventInfo?.isPublicRegistrationAllowed &&
        eventInfo?.isPublicRegistrationAllowed === true
      ) {
        setIsEventPrivate(false);
        setValue("eventInfo.eventType", eventConstants.PUBLIC);
      } else {
        setIsEventPrivate(true);
        setValue("eventInfo.eventType", eventConstants.PRIVATE);
      }
      eventInfo?.isMemebersExclusiveOnly &&
        setValue(
          "eventInfo.isMemebersExclusiveOnly",
          eventInfo?.isMemebersExclusiveOnly
        );
      eventInfo?.isMemebersExclusiveOnly &&
        setIsExclusiveForMembers(eventInfo?.isMemebersExclusiveOnly);

      const userTypeArray = [];
      if (eventInfo?.isGeneralUserAllowed) {
        userTypeArray.push("GENERAL_USER");
      }
      if (eventInfo?.isVerifiedUserAllowed) {
        userTypeArray.push("VERIFIED_USER");
      }
      if (eventInfo?.isPractionerAllowed) {
        userTypeArray.push("PRACTIONER");
      }
      setUserType(userTypeArray);
      setValue("eventInfo.userType", userTypeArray);

      eventInfo?.maximumParticipantsAllowed &&
        setValue(
          "eventInfo.maximumParticipantsAllowed",
          eventInfo?.maximumParticipantsAllowed
        );

      eventInfo?.cityid && setValue("eventInfo.cityId", eventInfo?.cityid);

      if (eventInfo?.lat && eventInfo?.long) {
        setSelectedSpotType(LocationConstants.CUSTOM_LOCATION);
        setValue("eventInfo.lat", eventInfo?.lat);
        setValue("eventInfo.long", eventInfo?.long);
        setValue("eventInfo.cityId", eventInfo?.cityId);
      }
      if (eventInfo?.spotId) {
        const selectedSpot = spots?.data?.find(
          (spot) => spot.id === eventInfo.spotId
        );
        if (selectedSpot) {
          if (selectedSpot.spotTypeId === LocationConstants.PUBLIC_SPOT) {
            setSelectedSpotType(LocationConstants.PUBLIC_SPOT);
            setValue("eventInfo.spotId", eventInfo?.spotId);
          } else if (
            selectedSpot.spotTypeId === LocationConstants.PRIVATE_SPOT
          ) {
            setSelectedSpotType(LocationConstants.PRIVATE_SPOT);
            setValue("eventInfo.spotId", eventInfo?.spotId);
          } else {
            setSelectedSpotType(LocationConstants.CUSTOM_LOCATION);
          }
        } else {
          setSelectedSpotType(LocationConstants.CUSTOM_LOCATION);
        }
      }
      if (eventData?.posters) {
        setPoster([eventData?.posters]);
      } else {
        setPoster([]);
      }
      if (eventData?.logo) {
        setLogo([eventData?.logo]);
      } else {
        setLogo([]);
      }

      if (eventData?.sports) {
        const filterOptions = getSportOptions()?.filter((option) =>
          eventData?.sports?.find((data) => data === option.value)
        );
        const serverSelectedBoatTypes = filterOptions?.map(
          (option) => option.value
        );
        setValue("Sports", serverSelectedBoatTypes);
        trigger("Sports");
        setSelectedOptions(filterOptions);
      }
    }
    //eslint-disable-next-line
  }, [dispatch, eventId, mode, eventData, setValue]);

  const getSportOptions = () => {
    return (
      Object.keys(sportConstants).map((sport) => {
        return {
          label: t(translationConstants[sport]),
          value: sportConstants[sport],
        };
      }) || []
    );
  };

  const filteredOptions = useMemo(() => {
    const options = getSportOptions();
    const updatedSelectedOptions = options.filter((option) =>
      selectedOptions.some((selected) => selected.value === option.value)
    );
    setSelectedOptions(updatedSelectedOptions);
    return options;
  }, [direction, t, sportConstants]);

  const [poster, setPoster] = useState([]);
  const [logo, setLogo] = useState([]);

  const dateLocationHandler = (data, event) => {
    if (
      !(eventData?.eventInfo?.status === EVENT_STATUS.Draft) &&
      !(
        event?.nativeEvent?.submitter?.id ===
          centerActivityConstants.UNPUBLISH_BUTTON ||
        event?.nativeEvent?.submitter?.id ===
          centerActivityConstants.PUBLISH_BUTTON
      )
    ) {
      setModalData(data);
      setModalEvent(event);
      setIsConfirmationModalOpen(!isConfirmationModalOpen);
    } else {
      onSubmit(data, event);
    }
  };

  const onSubmit = (data, event, errors) => {
    const buttonId = event?.nativeEvent?.submitter?.id;
    let status = null;

    if (
      buttonId === centerActivityConstants.ADD_BUTTON ||
      buttonId === centerActivityConstants.PUBLISH_BUTTON
    ) {
      status = eventStatusEnum.PUBLISHED;
    } else if (buttonId === centerActivityConstants.DRAFT_BUTTON) {
      status = eventStatusEnum.DRAFT;
    }

    let modifiedData = {
      ...data,
      eventInfo: {
        ...data.eventInfo,
        specialMemberFee: isSpecialMemberFeeEnable
          ? data.eventInfo.specialMemberFee
          : null,
        providedServices: selectedServices.join(", "),
        startDateString: mergeDateTimeToServerFormat(
          data.eventInfo.startDateString,
          data.eventInfo.startTime
        ),
        lat: data.eventInfo.lat === undefined ? null : data.eventInfo.lat,
        long: data.eventInfo.long === undefined ? null : data.eventInfo.long,
        endDateString: mergeDateTimeToServerFormat(
          data.eventInfo.endDateString,
          data?.eventInfo?.endTime
            ? data.eventInfo.endTime
            : moment().set(timezoneConstants.twelvePM).toDate()
        ),
        registrationStartDateString: mergeDateTimeToServerFormat(
          data.eventInfo.registrationStartDateString,
          moment().set(timezoneConstants.twelveAM).toDate()
        ),
        registrationEndDateString: mergeDateTimeToServerFormat(
          data.eventInfo.registrationEndDateString,
          moment().set(timezoneConstants.twelvePM).toDate()
        ),
        status: status !== null ? status : eventData?.eventInfo?.status,
        isPractionerAllowed: data?.eventInfo?.userType.includes("PRACTIONER"),
        isGeneralUserAllowed:
          data?.eventInfo?.userType.includes("GENERAL_USER"),
        isVerifiedUserAllowed:
          data?.eventInfo?.userType.includes("VERIFIED_USER"),
        isPublicRegistrationAllowed: isEventPrivate ? false : true,
      },
      logo: data.logo ? data.logo[0] : null,
      posters: data.posters ? data.posters[0] : null,
    };

    delete modifiedData.eventInfo.startTime;
    delete modifiedData.eventInfo.endTime;
    delete modifiedData.eventInfo.services;
    setSelectedServices([]);
    let formData = convertObjectToFormData(modifiedData);

    if (mode === "EDIT_MODE") {
      modifiedData = {
        ...modifiedData,
        Id: eventData?.id,
        IsPostersUpdated: isPosterChanged,
        IsLogoUpdated: isLogoChanged,
      };
      formData = convertObjectToFormData(modifiedData);
      dispatch(
        EventActions.updateEvent(formData, initialGridState, () => {
          navigate(viewPathConstants.EVENTS);
          setIsConfirmationModalOpen(false);
        })
      );
    } else {
      dispatch(
        EventActions.addEvent(formData, initialGridState, () => {
          navigate(viewPathConstants.EVENTS);
        })
      );
    }
  };

  useEffect(() => {
    const messageElements = [];

    if (isLocationChanged) {
      messageElements.push(
        <p key="locationChanged">
          {t(
            translationConstants.ARE_YOU_SURE_YOU_WANT_TO_CHANGE_THE_EVENT_LOCATION
          )}
        </p>
      );
    }

    if (isStartDateChanged) {
      messageElements.push(
        <p key="startDateChanged">
          {t(
            translationConstants.ARE_YOU_SURE_YOU_WANT_TO_CHANGE_THE_EVENT_DATES
          )}
        </p>
      );
    }

    setEditInformationMessage(messageElements);
    //eslint-disable-next-line
  }, [isLocationChanged, isStartDateChanged, t]);

  const handleFileUpload = useCallback(
    (file, key) => {
      if (key == "posters") {
        setIsPosterChanged(true);
      }
      if (key == "logo") {
        setIsLogoChanged(true);
      }
      setValue(key, file, { shouldValidate: true });
    },
    [setValue]
  );

  const isEventEndDateAfterOrEqualStartDate = (endDate) => {
    const startDate = getValues("eventInfo.startDateString");
    return (
      replaceLocalToUTCFormatZ(endDate).isSameOrAfter(
        replaceLocalToUTCFormatZ(startDate).startOf("day")
      ) || t(translationConstants.CENTER_END_DATE_NOT_BEFORE_START_DATE)
    );
  };

  const isRegistrationEndDateAfterOrEqualStartDate = (endDate) => {
    const startDate = getValues("eventInfo.registrationStartDateString");
    return (
      replaceLocalToUTCFormatZ(endDate).isSameOrAfter(
        replaceLocalToUTCFormatZ(startDate).startOf("day")
      ) || t(translationConstants.CENTER_END_DATE_NOT_BEFORE_START_DATE)
    );
  };

  const isRegistrationEndDateBeforeEventStartDate = (endDate) => {
    const eventStartDate = getValues("eventInfo.startDateString");
    return (
      replaceLocalToUTCFormatZ(endDate).isBefore(
        replaceLocalToUTCFormatZ(eventStartDate).startOf("day")
      ) ||
      t(
        translationConstants.registration_end_date_cant_greater_then_event_start_date
      )
    );
  };

  const onUpdateCancel = () => {
    setIsConfirmationModalOpen(false);
  };

  const isEventEndTimeAfterStartTimeIfSameDay = (endTime) => {
    const startDate = getValues("eventInfo.startDateString");
    const endDate = getValues("eventInfo.endDateString");
    const startTime = getValues("eventInfo.startTimeString");
    return (
      !endTime ||
      !replaceLocalToUTCFormatZ(endDate).isSame(
        replaceLocalToUTCFormatZ(startDate),
        "day"
      ) ||
      replaceLocalToUTCFormatZ(endTime).isAfter(
        replaceLocalToUTCFormatZ(startTime)
      ) ||
      t(translationConstants.CENTER_END_TIME_NOT_BEFORE_START_TIME)
    );
  };

  const disableDates = (withOneDay) => {
    if (withOneDay) {
      return new Date(UTCWithTimezoneToISOString(1));
    } else return new Date(UTCWithTimezoneToISOString());
  };

  return (
    <div className="d-flex container event-form">
      <div className="w-90-percent">
        <p className="UserTabHeading">
          {mode === modeConstants.EDIT_MODE
            ? t(translationConstants.EDIT_AN_EVENT)
            : t(translationConstants.CREATE_AN_EVENT)}
        </p>
        <div className="m-t-24">
          <FormProvider {...methods}>
            <Form
              noValidate
              onSubmit={
                mode === modeConstants.EDIT_MODE
                  ? handleSubmit(dateLocationHandler)
                  : handleSubmit(onSubmit)
              }
            >
              <Container>
                <Row>
                  <InputFieldWrapper
                    label={
                      `${t(translationConstants.event_title)}` +
                      Mandatory_Character
                    }
                  >
                    <Form.Control
                      type="text"
                      id="eventInfo.title"
                      placeholder={t(translationConstants.enter_event_title)}
                      {...register("eventInfo.title", {
                        required: t(
                          translationConstants.event_title_is_required
                        ),
                        maxLength: {
                          value:
                            fieldLengthConstants.EVENT_COMPETITION_NAME_FIELD_LENGTH,
                          message: t(translationConstants.EVENT_TITLE_TOO_LONG),
                        },
                      })}
                    />
                    {errors.eventInfo?.title && (
                      <p className="errorText">
                        {errors.eventInfo?.title.message}
                      </p>
                    )}
                  </InputFieldWrapper>

                  <InputFieldWrapper
                    label={
                      <>
                        {t(translationConstants.event_title)}
                        <span className="text-black">
                          {" "}
                          {t(translationConstants.ARABIC_WITH_BRACES)}:
                          <span className="greenColor">
                            {t(translationConstants.optional)}
                          </span>
                        </span>
                      </>
                    }
                  >
                    <Form.Control
                      {...register("eventInfo.arabicTitle", {
                        maxLength: {
                          value:
                            fieldLengthConstants.EVENT_COMPETITION_NAME_FIELD_LENGTH,
                          message: t(
                            translationConstants.EVENT_ARABIC_TITLE_TOO_LONG
                          ),
                        },
                      })}
                      id="eventInfo.arabicTitle"
                      type="text"
                      dir={Directions.rtl}
                      placeholder={"أدخل عنوان الحدث"}
                    />
                    {errors.eventInfo?.arabicTitle && (
                      <p className="errorText">
                        {errors.eventInfo?.arabicTitle.message}
                      </p>
                    )}
                  </InputFieldWrapper>

                  <InputFieldWrapper
                    md={12}
                    label={
                      `${t(translationConstants.DESCRIPTION)}:` +
                      Mandatory_Character
                    }
                  >
                    <Form.Control
                      type="text"
                      id="eventInfo.description"
                      as="textarea"
                      rows={3}
                      placeholder={t(
                        translationConstants.enter_event_description
                      )}
                      {...register("eventInfo.description", {
                        required: t(
                          translationConstants.EVENT_DESCRIPTION_REQUIRED
                        ),
                      })}
                    />
                    {errors.eventInfo?.description && (
                      <p className="errorText">
                        {errors.eventInfo?.description.message}
                      </p>
                    )}
                  </InputFieldWrapper>

                  <InputFieldWrapper
                    md={12}
                    label={
                      <>
                        {t(translationConstants.DESCRIPTION)}
                        <span className="greenText">
                          {" "}
                          {t(translationConstants.ARABIC_WITH_BRACES)}:
                        </span>
                      </>
                    }
                  >
                    <Form.Control
                      type="text"
                      id="eventInfo.arabicDescription"
                      as="textarea"
                      rows={3}
                      placeholder={t(
                        translationConstants.enter_event_description
                      )}
                      {...register("eventInfo.arabicDescription", {})}
                    />
                    {errors.eventInfo?.arabicDescription && (
                      <p className="errorText">
                        {errors.eventInfo?.arabicDescription.message}
                      </p>
                    )}
                  </InputFieldWrapper>

                  <InputFieldWrapper
                    label={
                      `${t(translationConstants.event_type)}` +
                      Mandatory_Character
                    }
                  >
                    <Form.Group>
                      <div className="d-flex radio-button mt-0 gap-3">
                        <Controller
                          name="eventInfo.eventType"
                          control={control}
                          defaultValue={eventConstants.PUBLIC}
                          {...register("eventInfo.eventType", {
                            required: t(
                              translationConstants.CENTER_NAME_REQUIRED
                            ),
                          })}
                          render={({ field }) => (
                            <>
                              <Form.Check
                                inline
                                type="radio"
                                id="inline-radio-public"
                                label={t(translationConstants.PUBLIC)}
                                value={eventConstants.PUBLIC}
                                checked={field.value === eventConstants.PUBLIC}
                                onChange={() => {
                                  field.onChange(eventConstants.PUBLIC);
                                  setIsEventPrivate(false);
                                }}
                              />
                              <Form.Check
                                inline
                                label={t(translationConstants.PRIVATE)}
                                type="radio"
                                id="inline-radio-private"
                                value={eventConstants.PRIVATE}
                                checked={field.value === eventConstants.PRIVATE}
                                onChange={() => {
                                  field.onChange(eventConstants.PRIVATE);
                                  setIsEventPrivate(true);
                                  setValue("eventInfo.registrationFee", null);
                                  setValue("eventInfo.specialMemberFee", null);
                                }}
                              />
                            </>
                          )}
                        />
                      </div>
                      {errors?.eventInfo?.eventType && (
                        <p className="errorText">
                          {errors.eventInfo?.eventType.message}
                        </p>
                      )}
                    </Form.Group>
                  </InputFieldWrapper>

                  <InputFieldWrapper
                    label={
                      `${t(translationConstants.exclusive_for_members)}` +
                      Mandatory_Character
                    }
                  >
                    <Form.Group>
                      <div className="d-flex radio-button mt-0 gap-3">
                        <Controller
                          name="eventInfo.isMemebersExclusiveOnly"
                          control={control}
                          disabled={mode === modeConstants.VIEW_MODE}
                          defaultValue={isExclusiveForMembers}
                          rules={{
                            validate: (value) =>
                              value === true ||
                              value === false ||
                              t(
                                translationConstants.COMPETITION_EXCLUSIVE_MEMBERS_REQUIRED
                              ),
                          }}
                          render={({ field }) => (
                            <>
                              <div className="d-flex gap-4">
                                <div className="">
                                  <Form.Check
                                    type="radio"
                                    id="yesExclusive"
                                    label={t(translationConstants.YES)}
                                    checked={field.value === true}
                                    value={true}
                                    onChange={() => {
                                      setIsExclusiveForMembers(true);
                                      setValue(
                                        "eventInfo.specialMemberFee",
                                        null
                                      );
                                      setIsSpecialMemberFeeEnable(false);
                                      field.onChange(true);
                                    }}
                                  />
                                </div>
                                <Form.Check
                                  type="radio"
                                  id="noExclusive"
                                  label={t(translationConstants.NO)}
                                  checked={field.value === false}
                                  value={false}
                                  onChange={() => {
                                    setIsExclusiveForMembers(false);
                                    field.onChange(false);
                                  }}
                                />
                              </div>
                              {errors?.CompetitionInfo
                                ?.IsMemebersExclusiveOnly && (
                                <p className="errorText">
                                  {
                                    errors?.CompetitionInfo
                                      ?.IsMemebersExclusiveOnly?.message
                                  }
                                </p>
                              )}
                            </>
                          )}
                        />
                      </div>
                      {errors?.eventInfo?.isMemebersExclusiveOnly && (
                        <p className="errorText">
                          {errors?.eventInfo?.isMemebersExclusiveOnly.message}
                        </p>
                      )}
                    </Form.Group>
                  </InputFieldWrapper>

                  <InputFieldWrapper
                    label={appendMandatorySignAndTimezoneText(
                      t(translationConstants.event_start_date),
                      t
                    )}
                  >
                    <Controller
                      name="eventInfo.startDateString"
                      control={control}
                      rules={{
                        required: t(
                          translationConstants.event_start_date_is_required
                        ),
                      }}
                      render={({ field }) => (
                        <ReactDatePickerWrapper
                          onChange={(date) => {
                            field.onChange(date);
                            setIsStartDateChanged(true);
                          }}
                          selected={field.value}
                          minDate={disableDates(true)}
                          value={field.value}
                          disabled={props.mode === modeConstants.VIEW_MODE}
                        />
                      )}
                    />
                    {errors?.eventInfo?.startDateString && (
                      <p className="errorText">
                        {errors?.eventInfo?.startDateString.message}
                      </p>
                    )}
                  </InputFieldWrapper>

                  <InputFieldWrapper
                    label={appendMandatorySignAndTimezoneText(
                      t(translationConstants.event_end_date),
                      t
                    )}
                  >
                    <Controller
                      name="eventInfo.endDateString"
                      control={control}
                      rules={{
                        required: t(
                          translationConstants.event_end_date_is_required
                        ),
                        validate: {
                          isEventEndDateAfterOrEqualStartDate:
                            isEventEndDateAfterOrEqualStartDate,
                        },
                      }}
                      render={({ field }) => (
                        <ReactDatePickerWrapper
                          onChange={(date) => {
                            field.onChange(date);
                          }}
                          selected={field.value}
                          minDate={disableDates(true)}
                          value={field.value}
                          disabled={props.mode === modeConstants.VIEW_MODE}
                        />
                      )}
                    />
                    {errors?.eventInfo?.endDateString && (
                      <p className="errorText">
                        {errors?.eventInfo?.endDateString.message}
                      </p>
                    )}
                  </InputFieldWrapper>

                  <InputFieldWrapper
                    label={appendMandatorySignAndTimezoneText(
                      t(translationConstants.CENTER_START_TIME),
                      t
                    )}
                  >
                    <Controller
                      name="eventInfo.startTime"
                      control={control}
                      rules={{
                        required: t(
                          translationConstants.event_start_time_is_required
                        ),
                      }}
                      render={({ field }) => (
                        <ReactDatePickerWrapper
                          onChange={(time) => {
                            field.onChange(time);
                          }}
                          isTimePicker={true}
                          selected={field.value}
                          value={field.value}
                          disabled={props.mode === modeConstants.VIEW_MODE}
                        />
                      )}
                    />
                    {errors?.eventInfo?.startTime && (
                      <p className="errorText">
                        {errors?.eventInfo?.startTime.message}
                      </p>
                    )}
                  </InputFieldWrapper>

                  <InputFieldWrapper
                    label={<>{t(translationConstants.CENTER_END_TIME)}:</>}
                    isShowTimezone={true}
                  >
                    <Controller
                      name="eventInfo.endTime"
                      control={control}
                      rules={{
                        validate: {
                          isEventEndTimeAfterStartTimeIfSameDay:
                            isEventEndTimeAfterStartTimeIfSameDay,
                        },
                      }}
                      render={({ field }) => (
                        <ReactDatePickerWrapper
                          onChange={(time) => {
                            field.onChange(time);
                          }}
                          isTimePicker={true}
                          selected={field.value}
                          value={field.value}
                          disabled={props.mode === modeConstants.VIEW_MODE}
                        />
                      )}
                    />
                    {errors?.eventInfo?.endTime && (
                      <p className="errorText">
                        {errors?.eventInfo?.endTime.message}
                      </p>
                    )}
                  </InputFieldWrapper>

                  <InputFieldWrapper
                    label={appendMandatorySignAndTimezoneText(
                      t(translationConstants.registration_start_date),
                      t
                    )}
                  >
                    <Controller
                      name="eventInfo.registrationStartDateString"
                      control={control}
                      rules={{
                        required: t(
                          translationConstants.registration_start_date_is_required
                        ),
                      }}
                      render={({ field }) => (
                        <ReactDatePickerWrapper
                          onChange={(date) => {
                            field.onChange(date);
                          }}
                          selected={field.value}
                          minDate={disableDates(false)}
                          value={field.value}
                          disabled={props.mode === modeConstants.VIEW_MODE}
                        />
                      )}
                    />
                    {errors?.eventInfo?.registrationStartDateString && (
                      <p className="errorText">
                        {errors?.eventInfo?.registrationStartDateString.message}
                      </p>
                    )}
                  </InputFieldWrapper>

                  <InputFieldWrapper
                    label={appendMandatorySignAndTimezoneText(
                      t(translationConstants.registration_end_date),
                      t
                    )}
                  >
                    <Controller
                      name="eventInfo.registrationEndDateString"
                      control={control}
                      rules={{
                        required: t(
                          translationConstants.registration_end_date_is_required
                        ),
                        validate: {
                          isRegistrationEndDateBeforeOrEqualEventStartDate:
                            isRegistrationEndDateBeforeEventStartDate,
                          isRegistrationEndDateAfterOrEqualStartDate:
                            isRegistrationEndDateAfterOrEqualStartDate,
                        },
                      }}
                      render={({ field }) => (
                        <ReactDatePickerWrapper
                          onChange={(date) => {
                            field.onChange(date);
                          }}
                          selected={field.value}
                          minDate={disableDates(false)}
                          value={field.value}
                          disabled={props.mode === modeConstants.VIEW_MODE}
                        />
                      )}
                    />
                    {errors?.eventInfo?.registrationEndDateString && (
                      <p className="errorText">
                        {errors?.eventInfo?.registrationEndDateString.message}
                      </p>
                    )}
                  </InputFieldWrapper>

                  {/* Location */}
                  <Col md={6} className="mb-10px">
                    <div className="d-flex gap-2 flex-wrap">
                      <Form.Label className="Form-labels">
                        {t(translationConstants.LOCATION) + Mandatory_Character}
                      </Form.Label>
                      <div className="d-flex flex-wrap">
                        <Form.Check
                          className="mt-negative-10 small-checkbox me-2"
                          type="checkbox"
                          checked={
                            selectedSpotType === LocationConstants.PUBLIC_SPOT
                          }
                          label={t(translationConstants.PUBLIC_SPOT)}
                          onChange={() => {
                            handleCheckboxChange(LocationConstants.PUBLIC_SPOT);
                            setIsLocationChanged(true);
                            setValue("eventInfo.lat", null);
                            setValue("eventInfo.long", null);
                          }}
                        />
                        <Form.Check
                          className="mt-negative-10 small-checkbox me-2"
                          type="checkbox"
                          checked={
                            selectedSpotType === LocationConstants.PRIVATE_SPOT
                          }
                          label={t(translationConstants.PRIVATE_SPOT)}
                          onChange={() => {
                            handleCheckboxChange(
                              LocationConstants.PRIVATE_SPOT
                            );
                            setIsLocationChanged(true);
                            setValue("eventInfo.lat", null);
                            setValue("eventInfo.long", null);
                          }}
                        />
                        <Form.Check
                          className="mt-negative-10 small-checkbox me-2"
                          type="checkbox"
                          checked={
                            selectedSpotType ===
                            LocationConstants.CUSTOM_LOCATION
                          }
                          label={t(translationConstants.custom_location)}
                          onChange={() => {
                            handleCheckboxChange(
                              LocationConstants.CUSTOM_LOCATION
                            );
                            setIsLocationChanged(true);
                            setValue("eventInfo.spotId", null);
                          }}
                        />
                      </div>
                    </div>
                    <div>
                      {selectedSpotType === LocationConstants.PUBLIC_SPOT && (
                        <>
                          <Form.Select
                            id="eventInfo.spotId"
                            {...register("eventInfo.spotId", {
                              required:
                                selectedSpotType ===
                                  LocationConstants.PUBLIC_SPOT &&
                                t(
                                  translationConstants.CENTER_ACTIVITY_LOCATION_REQUIRED
                                ),
                            })}
                            onChange={() => {
                              setIsLocationChanged(true);
                            }}
                          >
                            <option value="">
                              {t(translationConstants.SELECT_PUBLIC_SPOT)}
                            </option>
                            {spots.data
                              ?.filter((spot) => spot.spotTypeId === 0)
                              .map((spot) => (
                                <option key={spot.id} value={spot.id}>
                                  {direction === Direction.RTL
                                    ? spot?.arabicName || spot?.name
                                    : spot?.name}
                                </option>
                              ))}
                          </Form.Select>
                          {errors?.eventInfo?.spotId && (
                            <p className="errorText">
                              {errors?.eventInfo.spotId.message}
                            </p>
                          )}
                        </>
                      )}
                      {selectedSpotType === LocationConstants.PRIVATE_SPOT && (
                        <>
                          <Form.Select
                            id="eventInfo.spotId"
                            {...register("eventInfo.spotId", {
                              required:
                                selectedSpotType ===
                                  LocationConstants.PRIVATE_SPOT &&
                                t(
                                  translationConstants.CENTER_ACTIVITY_LOCATION_REQUIRED
                                ),
                            })}
                            onChange={() => setIsLocationChanged(true)}
                          >
                            <option value="">
                              {t(translationConstants.SELECT_PRIVATE_SPOT)}
                            </option>
                            {spots.data
                              ?.filter(
                                (spot) =>
                                  spot.spotTypeId ===
                                  LocationConstants.PRIVATE_SPOT
                              )
                              .map((spot) => (
                                <option key={spot.id} value={spot.id}>
                                  {direction === Direction.RTL
                                    ? spot?.arabicName || spot?.name
                                    : spot?.name}
                                </option>
                              ))}
                          </Form.Select>
                          {errors?.eventInfo?.spotId && (
                            <p className="errorText">
                              {errors?.eventInfo.spotId.message}
                            </p>
                          )}
                        </>
                      )}
                      {selectedSpotType ===
                        LocationConstants.CUSTOM_LOCATION && (
                        <>
                          <Form.Select
                            id="eventInfo.cityId"
                            {...register("eventInfo.cityId", {
                              required:
                                selectedSpotType ===
                                  LocationConstants.CUSTOM_LOCATION &&
                                t(translationConstants.CITY_IS_REQUIRED),
                            })}
                            onChange={() => setIsLocationChanged(true)}
                          >
                            <option value="">
                              {t(translationConstants.PLEASE_SELECT_A_CITY)}
                            </option>
                            {cities?.map((city) => (
                              <option key={city.id} value={city.id}>
                                {direction === Direction.RTL
                                  ? city?.arabicName || city?.name
                                  : city?.name}
                              </option>
                            ))}
                          </Form.Select>
                          {errors?.eventInfo?.cityId && (
                            <p className="errorText">
                              {errors?.eventInfo?.cityId.message}
                            </p>
                          )}
                        </>
                      )}
                    </div>
                  </Col>
                  {/* Coordinates */}
                  {selectedSpotType === LocationConstants.CUSTOM_LOCATION && (
                    <Col md={6} className="">
                      <div className="">
                        <Form.Label className="Form-labels">
                          {t(translationConstants.SPOT_COORDINATES) +
                            Mandatory_Character}
                          :
                        </Form.Label>

                        <div className="row">
                          <div className="d-flex justify-content-between justify-content-md-start gap-lg-2 gap-0 col-md-7 col-12">
                            <Form.Group className="">
                              <Form.Control
                                {...register("eventInfo.lat", {
                                  required:
                                    selectedSpotType ===
                                      LocationConstants.CUSTOM_LOCATION &&
                                    t(translationConstants.LAT_REQUIRED),
                                  pattern: {
                                    value:
                                      /^-?([1-8]?[0-9](\.\d+)?|90(\.0+)?)$/,
                                    message: t(
                                      translationConstants.LAT_RANGE_VALIDATION_TEXT
                                    ),
                                  },
                                })}
                                id="eventInfo.lat"
                                className="w-100px"
                                type="text"
                                disabled={
                                  selectedSpotType !==
                                  LocationConstants.CUSTOM_LOCATION
                                }
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setIsLocationChanged(true);
                                }}
                              />
                              {errors.eventInfo?.Lat && (
                                <p className="errorText">
                                  {errors.eventInfo?.Lat.message}
                                </p>
                              )}
                            </Form.Group>
                            <Form.Group className="">
                              <Form.Control
                                {...register("eventInfo.long", {
                                  required:
                                    selectedSpotType ===
                                      LocationConstants.CUSTOM_LOCATION &&
                                    t(translationConstants.LNG_REQUIRED),
                                  pattern: {
                                    value:
                                      /^-?((([1-9]?[0-9]|1[0-7][0-9])(\.\d+)?)|180(\.0+)?)$/,
                                    message: t(
                                      translationConstants.LNG_RANGE_VALIDATION_TEXT
                                    ),
                                  },
                                })}
                                id="eventInfo.long"
                                type="text"
                                className="w-100px"
                                disabled={
                                  selectedSpotType !==
                                  LocationConstants.CUSTOM_LOCATION
                                }
                                onChange={(e) => {
                                  const value = e.target.value;
                                }}
                              />
                              {errors.eventInfo?.Long && (
                                <p className="errorText">
                                  {errors.eventInfo.Long.message}
                                </p>
                              )}
                            </Form.Group>
                          </div>

                          <div className="col-md-5 col-12">
                            <Form.Group className="d-flex justify-content-between">
                              <Button
                                disabled={
                                  selectedSpotType !==
                                  LocationConstants.CUSTOM_LOCATION
                                }
                                className="find-on-map-button back-none m-md-auto m-3 d-md-flex d-block "
                                type="button"
                                onClick={onSetShowMap}
                              >
                                {t(translationConstants.FIND_ON_MAP)}
                              </Button>
                            </Form.Group>
                          </div>
                        </div>
                      </div>
                    </Col>
                  )}

                  <InputFieldWrapper
                    label={
                      `${t(translationConstants.maximum_participants)}:` +
                      Mandatory_Character
                    }
                  >
                    <Form.Control
                      type="number"
                      id="eventInfo.maximumParticipantsAllowed"
                      placeholder={t(translationConstants.maximum_participants)}
                      {...register("eventInfo.maximumParticipantsAllowed", {
                        required: t(
                          translationConstants.maximum_participants_allowed_is_required
                        ),
                        min: {
                          value: 1,
                          message: t(
                            translationConstants.MAXIMUM_PARTICIPANTS_MUST_BE_GREATER_THAN_0
                          ),
                        },
                      })}
                    />
                    {errors?.eventInfo?.maximumParticipantsAllowed && (
                      <p className="errorText">
                        {errors?.eventInfo?.maximumParticipantsAllowed.message}
                      </p>
                    )}
                  </InputFieldWrapper>

                  <InputFieldWrapper
                    label={
                      `${t(translationConstants.user_type)}:` +
                      Mandatory_Character
                    }
                  >
                    <div className="">
                      <div className="d-flex ga-2 flex-wrap">
                        {[
                          {
                            label: t(translationConstants.GENERAL_USER),
                            value: "GENERAL_USER",
                          },
                          {
                            label: t(translationConstants.VERIFIED_USER),
                            value: "VERIFIED_USER",
                          },
                          {
                            label: t(translationConstants.SAILOR),
                            value: "PRACTIONER",
                          },
                        ].map((option, index) => (
                          <Form.Group
                            key={index}
                            className="p-left-0 p-right-0"
                            controlId={option.value}
                          >
                            <Form.Check
                              className="offer"
                              type="checkbox"
                              value={option.value}
                              label={<p>{option.label}</p>}
                              {...register(`eventInfo.userType`, {
                                validate: {
                                  atLeastOne: (value) =>
                                    value.length > 0 ||
                                    t(
                                      translationConstants.atleast_one_user_is_required
                                    ),
                                },
                              })}
                            />
                          </Form.Group>
                        ))}
                      </div>
                    </div>
                    {errors?.eventInfo?.userType && (
                      <p className="errorText">
                        {errors.eventInfo.userType.message}
                      </p>
                    )}
                  </InputFieldWrapper>

                  <InputFieldWrapper
                    label={
                      `${t(translationConstants.SPORT_TYPE)}:` +
                      Mandatory_Character
                    }
                  >
                    <Controller
                      control={control}
                      name="Sports"
                      rules={{
                        required: t(
                          translationConstants.EVENT_SPORT_TYPE_REQUIRED
                        ),
                      }}
                      render={({ field }) => (
                        <MultiSelect
                          id="Sports"
                          isMulti
                          options={filteredOptions}
                          value={selectedOptions}
                          placeholder={t(
                            translationConstants.SELECT_SPORT_TYPE
                          )}
                          onChange={(val) => {
                            setSelectedOptions(val);
                            field.onChange(val?.map((item) => item.value));
                            trigger("Sports");
                          }}
                        />
                      )}
                    />
                    {errors?.Sports && (
                      <p className="errorText">{errors?.Sports.message}</p>
                    )}
                  </InputFieldWrapper>

                  {getValues("eventInfo.eventType") ===
                    eventConstants.PUBLIC && (
                    <>
                      <InputFieldWrapper
                        label={
                          <>
                            {t(translationConstants.registration_fees)}:
                            {Mandatory_Character}{" "}
                            <span className="greenText">
                              {t(translationConstants.SAR_WITH_BRACES)}
                            </span>{" "}
                            {t(translationConstants.VAT)}{" "}
                            {t(translationConstants.EXCLUDED)}
                          </>
                        }
                      >
                        <Form.Group>
                          <div className="d-flex radio-button mt-0 gap-3">
                            <Form.Check
                              inline
                              type="radio"
                              id="inline-radio-yes"
                              label={t(translationConstants.YES)}
                              value={true}
                              checked={isReistrationFees === true}
                              onChange={() => {
                                setIsReistrationFees(true);
                              }}
                            />
                            <Form.Check
                              inline
                              label={t(translationConstants.NO)}
                              type="radio"
                              id="inline-radio-no"
                              value={false}
                              checked={isReistrationFees === false}
                              onChange={() => {
                                setIsReistrationFees(false);
                                setValue("eventInfo.registrationFee", null);
                                setValue("eventInfo.specialMemberFee", null);
                                clearErrors("eventInfo.registrationFee");
                                clearErrors("eventInfo.specialMemberFee");
                              }}
                            />
                            <Form.Control
                              type="number"
                              id="eventInfo.registrationFee"
                              disabled={!isReistrationFees}
                              {...register("eventInfo.registrationFee", {
                                min: {
                                  value: 1,
                                  message: t(
                                    translationConstants.MINIMUM_VALUE_SHOULD_BE_1
                                  ),
                                },
                                validate: (value) => {
                                  if (isReistrationFees && !value) {
                                    return t(
                                      translationConstants.registration_fees_is_required
                                    );
                                  }
                                  return true;
                                },
                              })}
                            />
                          </div>
                          {errors.eventInfo?.registrationFee && (
                            <p className="errorText">
                              {errors.eventInfo?.registrationFee.message}
                            </p>
                          )}
                        </Form.Group>
                      </InputFieldWrapper>

                      {!isExclusiveForMembers && (
                        <Col>
                          <div className="d-flex gap-3">
                            <Form.Label className="Form-labels">
                              {t(translationConstants.special_fee_for_members)}:{" "}
                              <span className="greenText">
                                {t(translationConstants.SAR_WITH_BRACES)}
                              </span>{" "}
                              {t(translationConstants.VAT)}{" "}
                              {t(translationConstants.EXCLUDED)}
                            </Form.Label>
                            <Form.Check
                              className="mt-negative-10"
                              type="checkbox"
                              checked={isSpecialMemberFeeEnable}
                              label={t(translationConstants.ENABLE)}
                              onChange={(e) => {
                                setValue("eventInfo.specialMemberFee", null);
                                setIsSpecialMemberFeeEnable((prev) => !prev);
                                const isChecked = e.target.checked;
                                if (!isChecked) {
                                  setValue("eventInfo.specialMemberFee", null);
                                  clearErrors("eventInfo.specialMemberFee");
                                }
                              }}
                              disabled={!isReistrationFees}
                            />
                          </div>
                          <div>
                            <Form.Control
                              type="number"
                              id="eventInfo.specialMemberFee"
                              disabled={
                                !isReistrationFees || !isSpecialMemberFeeEnable
                              }
                              placeholder={t(
                                translationConstants.special_fee_for_members
                              )}
                              {...register("eventInfo.specialMemberFee", {
                                min: {
                                  value: 1,
                                  message: t(
                                    translationConstants.MINIMUM_VALUE_SHOULD_BE_1
                                  ),
                                },
                                required:
                                  isSpecialMemberFeeEnable &&
                                  isReistrationFees &&
                                  t(
                                    translationConstants.special_fee_for_members_is_required
                                  ),
                              })}
                            />
                            {errors?.eventInfo?.specialMemberFee && (
                              <p className="errorText">
                                {errors.eventInfo.specialMemberFee.message}
                              </p>
                            )}
                          </div>
                        </Col>
                      )}
                    </>
                  )}

                  <InputFieldWrapper
                    label={`${t(translationConstants.service_included)}:`}
                  >
                    <div className="">
                      <div className="d-flex ga-2 flex-wrap">
                        {serviceOptions.map((option, index) => (
                          <Form.Group
                            key={index}
                            className="p-left-0 p-right-0"
                            controlId={option.value}
                          >
                            <Form.Check
                              className="offer"
                              type="checkbox"
                              value={option.value}
                              label={<p>{option.label}</p>}
                              checked={selectedServices.includes(option.value)}
                              onChange={() =>
                                handleServiceCheckboxChange(option.value)
                              }
                            />
                          </Form.Group>
                        ))}
                      </div>
                    </div>
                    {errors.eventInfo?.services && (
                      <p className="errorText">
                        {errors.eventInfo.services.message}
                      </p>
                    )}
                  </InputFieldWrapper>

                  <InputFieldWrapper
                    lg={6}
                    md={12}
                    label={
                      <>
                        {t(translationConstants.upload_event_poster) +
                          Mandatory_Character}
                        :{" "}
                      </>
                    }
                  >
                    <div className="filterUploader">
                      <FileUploader
                        single
                        isImage={true}
                        defaultValue={poster}
                        {...register("posters", {
                          required:
                            mode === modeConstants.EDIT_MODE
                              ? poster.length < 1 &&
                                t(translationConstants.EVENT_POSTER_REQUIRED)
                              : t(translationConstants.EVENT_POSTER_REQUIRED),
                        })}
                        onFileUpload={(file) =>
                          handleFileUpload(file, "posters")
                        }
                        setValidationErrorMessage={setPosterMessage}
                        isError={errors?.posters}
                        isAllowPreview={
                          props.currentAction === globalGridActions.VIEW ||
                          props.currentAction === globalGridActions.EDIT
                        }
                        onFileRemove={() => {
                          setPoster([]);
                        }}
                      />
                      <p className="RecommendationText">
                        {t(translationConstants.POSTER_RECOMMENDED_SIZE)}
                      </p>
                      {errors?.posters && !posterMessage && (
                        <p className="errorText">{errors?.posters.message}</p>
                      )}
                      {posterMessage && (
                        <p className="errorText">{posterMessage}</p>
                      )}
                    </div>
                  </InputFieldWrapper>

                  <InputFieldWrapper
                    lg={6}
                    md={12}
                    label={
                      <>
                        {t(translationConstants.UPLOAD_LOGO) +
                          Mandatory_Character}
                        :
                      </>
                    }
                  >
                    <div className="filterUploader">
                      <FileUploader
                        single
                        isImage={true}
                        defaultValue={logo}
                        {...register("logo", {
                          required:
                            mode === modeConstants.EDIT_MODE
                              ? logo.length < 1 &&
                                t(translationConstants.EVENT_LOGO_REQUIRED)
                              : t(translationConstants.EVENT_LOGO_REQUIRED),
                        })}
                        onFileUpload={(file) => handleFileUpload(file, "logo")}
                        setValidationErrorMessage={setLogoMessage}
                        isError={errors.logo || logoMessage}
                        isAllowPreview={
                          props.currentAction === globalGridActions.VIEW ||
                          props.currentAction === globalGridActions.EDIT
                        }
                        onFileRemove={() => {
                          setLogo([]);
                        }}
                      />
                      {errors?.logo && (
                        <p className="errorText">{errors?.logo.message}</p>
                      )}
                      {logoMessage && (
                        <p className="errorText">{logoMessage}</p>
                      )}
                    </div>
                  </InputFieldWrapper>
                </Row>
                <Row className="d-flex justify-content-center my-5 mx-lg-5">
                  {mode === modeConstants.EDIT_MODE ? (
                    eventData?.eventInfo?.status ===
                      centerActivityStatusEnum.UNPUBLISHED ||
                    eventData?.eventInfo?.status ===
                      centerActivityStatusEnum.DRAFT ? (
                      <Col className="mx-1 d-flex justify-content-center">
                        <Button
                          id={centerActivityConstants.PUBLISH_BUTTON}
                          className="btn-submit mb-2"
                          onClick={() => {
                            dispatch(
                              EventActions.updateEventStatusById(
                                eventData?.id,
                                eventStatusEnum.PUBLISHED,
                                initialGridState,
                                () => {
                                  navigate(viewPathConstants.EVENTS);
                                  setIsConfirmationModalOpen(false);
                                }
                              )
                            );
                          }}
                        >
                          {t(translationConstants.PUBLISH)}
                        </Button>
                      </Col>
                    ) : (
                      <Col className="mx-1 d-flex justify-content-center">
                        <Button
                          id={centerActivityConstants.UNPUBLISH_BUTTON}
                          className="btn-submit mb-2"
                          onClick={() => {
                            dispatch(
                              EventActions.updateEventStatusById(
                                eventData?.id,
                                eventStatusEnum.UNPUBLISHED,
                                initialGridState,
                                () => {
                                  navigate(viewPathConstants.EVENTS);
                                  setIsConfirmationModalOpen(false);
                                }
                              )
                            );
                          }}
                        >
                          {t(translationConstants.UNPUBLISH)}
                        </Button>
                      </Col>
                    )
                  ) : (
                    <Col className="mx-1 d-flex justify-content-center">
                      <Button
                        id={centerActivityConstants.ADD_BUTTON}
                        className="btn-submit mb-2"
                        type="submit"
                      >
                        {t(translationConstants.CREATE_AND_PUBLISH)}
                      </Button>
                    </Col>
                  )}
                  {mode === modeConstants.EDIT_MODE ? (
                    <Col className="mx-1 d-flex justify-content-center">
                      <Button
                        id={centerActivityConstants.UPDATE_BUTTON}
                        className="btn-submit mb-2"
                        type="submit"
                      >
                        {t(translationConstants.Update)}
                      </Button>
                    </Col>
                  ) : (
                    <Col className="mx-1 d-flex justify-content-center">
                      <Button
                        id={centerActivityConstants.DRAFT_BUTTON}
                        className="btn-submit mb-2"
                        type="submit"
                      >
                        {t(translationConstants.SAVE_DRAFT)}
                      </Button>
                    </Col>
                  )}
                  <Col className="mx-1 d-flex justify-content-center">
                    <Button
                      className="reject-button m-0"
                      type="button"
                      onClick={() => navigate(-1)}
                    >
                      {t(translationConstants.cancel)}
                    </Button>
                  </Col>
                </Row>
              </Container>
            </Form>
          </FormProvider>
        </div>
      </div>
      <CustomModal
        size="lg"
        scrollable={true}
        setShow={onSetShowMap}
        show={isShowMap}
      >
        <FindOnMapModal
          setLng={setLng}
          setLat={setLat}
          lat={lat}
          lng={lng}
          handleSubmitLocation={handleSaveLocation}
        />
      </CustomModal>
      <CustomModal
        size="md"
        scrollable={true}
        setShow={() => dateLocationHandler()}
        show={isConfirmationModalOpen}
        customClass="view-user-modal"
      >
        <ConfirmationModal
          title={t(translationConstants.CONFIRMATION)}
          messageLine1={editInformationMessage}
          messageLine2={
            isLocationChanged || isStartDateChanged
              ? t(
                  translationConstants.AN_EMAIL_WILL_BE_SENT_TO_ALL_THE_REGISTERED_PARTICIPANTS
                )
              : t(translationConstants.are_you_sure_you_want_to_update)
          }
          onSubmit={() => onSubmit(modalData, modalEvent)}
          onCancel={onUpdateCancel}
        />
      </CustomModal>
    </div>
  );
};

export default EventForm;
